import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import styles from './RadioCard.module.css';

export const RadioCardForm = ({ selectedOption, onOptionChange, children }) => {
  if (children.length === 0) {
    return null;
  }
  return (
    <form className={styles.form} data-testid="radio-card-form">
      {children.map((child) => (
        <div
          key={child?.props?.id}
          className={cx(
            styles.option,
            selectedOption?.value === child?.props?.value ? styles.selected : null,
          )}
          role="button"
        >
          <label htmlFor={child.props.id} className={styles.labelWrap}>
            <input
              id={child.props.id}
              type="radio"
              value={child.props.value}
              checked={selectedOption?.value === child?.props?.value}
              onChange={(e) => onOptionChange({ event: e, node: child?.props })}
              className={styles.radioInput}
              aria-describedby={`${child?.props?.value}-description`}
            />
            {child}
          </label>
        </div>
      ))}
    </form>
  );
};

RadioCardForm.defaultProps = {
  selectedOption: null,
};

RadioCardForm.propTypes = {
  selectedOption: PropTypes.shape({
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  }),
  onOptionChange: PropTypes.func.isRequired,
  children: PropTypes.arrayOf(PropTypes.node).isRequired,
};
